import React from "react";
import { timePickerUtils } from "../../utils/dateFormatUtils";

const TimePicker = ({
    id,
    name,
    value,
    onChange,
    placeholder = "Select time",
    className = "",
    required = false,
    format = "h:mm A",
    disabled = false,
    useUtc = true,
    ...rest
}) => {
    const handleTimeChange = (e) => {
        const timeValue = e.target.value;
        if (timeValue) {
            const formattedTime = timePickerUtils.inputToFormatted(
                timeValue,
                format,
                useUtc
            );
            onChange(formattedTime);
        } else {
            onChange("");
        }
    };

    const getInputValue = () => {
        return timePickerUtils.formattedToInput(value, format, useUtc);
    };

    return (
        <div className="timepicker-wrapper">
            <input
                id={id}
                name={name}
                type="time"
                placeholder={placeholder}
                value={getInputValue()}
                onChange={handleTimeChange}
                className={`form-control font-family-source-sans-400 ${className}`}
                required={required}
                disabled={disabled}
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1,
                }}
                {...rest}
            />
        </div>
    );
};

export default TimePicker;
